/**
 * Format a past timestamp (ms since epoch) as a short relative string.
 * Future timestamps and anything under a minute read as "just now".
 * A week or older falls back to a locale date. `now` is injectable for tests.
 */
export function formatRelativeTime(ms: number, now: number = Date.now()): string {
  const diff = now - ms
  if (diff < 60_000) return 'just now'
  const minutes = Math.floor(diff / 60_000)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d ago`
  return new Date(ms).toLocaleDateString()
}
